import script from "./Localization.vue?vue&type=script&setup=true&lang=ts"
export * from "./Localization.vue?vue&type=script&setup=true&lang=ts"

import "./Localization.vue?vue&type=style&index=0&id=a18f728a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a18f728a"]])

export default __exports__